import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { ProtectedRoute } from './auth/ProtectedRoute'
import { ConsoleLayout } from './layouts/ConsoleLayout'
import { PublicLayout } from './layouts/PublicLayout'
import { CatalogPage } from './pages/console/CatalogPage'
import { ConsoleDashboardPage } from './pages/console/ConsoleDashboardPage'
import { DraftsPage } from './pages/console/DraftsPage'
import { OperationsPage } from './pages/console/OperationsPage'
import { ServiceLaunchpadPage } from './pages/console/ServiceLaunchpadPage'
import { WorkloadsPage } from './pages/console/WorkloadsPage'
import { LedgerDetailPage } from './pages/public/LedgerDetailPage'
import { LedgerPage } from './pages/public/LedgerPage'
import { LoginPage } from './pages/public/LoginPage'
import { NotFoundPage } from './pages/public/NotFoundPage'
import { ObservatoryPage } from './pages/public/ObservatoryPage'
import { ResearchPage } from './pages/public/ResearchPage'
import { ServicesPage } from './pages/public/ServicesPage'
import { StewardshipPage } from './pages/public/StewardshipPage'

const JourneyPage = lazy(() => import('./journey/JourneyPage'))
const PresentationPage = lazy(() => import('./presentation/PresentationPage'))
const PresentationRemotePage = lazy(() => import('./presentation/PresentationRemotePage'))
const ResourcesPage = lazy(() => import('./resources/ResourcesPage'))

export function App() {
  return (
    <Routes>
      <Route
        index
        element={
          <Suspense fallback={<div style={{ minHeight: '100vh', background: '#07080b' }} />}>
            <JourneyPage />
          </Suspense>
        }
      />
      <Route
        path="presentation"
        element={
          <Suspense fallback={<div style={{ minHeight: '100vh', background: '#ffffff' }} />}>
            <PresentationPage />
          </Suspense>
        }
      />
      <Route
        path="presentation-remote"
        element={
          <Suspense fallback={<div style={{ minHeight: '100vh', background: '#f4f7fb' }} />}>
            <PresentationRemotePage />
          </Suspense>
        }
      />
      {['resources', 'resources/:category'].map((path) => (
        <Route
          key={path}
          path={path}
          element={
            <Suspense fallback={<div style={{ minHeight: '100vh', background: '#f2efe9' }} />}>
              <ResourcesPage />
            </Suspense>
          }
        />
      ))}
      <Route element={<PublicLayout />}>
        <Route path="observatory" element={<ObservatoryPage />} />
        <Route path="ledger" element={<LedgerPage />} />
        <Route path="ledger/:eventId" element={<LedgerDetailPage />} />
        <Route path="services" element={<ServicesPage />} />
        <Route path="research" element={<ResearchPage />} />
        <Route path="stewardship" element={<StewardshipPage />} />
      </Route>
      <Route path="login" element={<LoginPage />} />
      <Route
        path="console"
        element={
          <ProtectedRoute>
            <ConsoleLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<ConsoleDashboardPage />} />
        <Route
          path="drafts"
          element={
            <ProtectedRoute role="member">
              <DraftsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="workloads"
          element={
            <ProtectedRoute role="member">
              <WorkloadsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="operations"
          element={
            <ProtectedRoute role="operator">
              <OperationsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="services"
          element={
            <ProtectedRoute role="member">
              <ServiceLaunchpadPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="catalog"
          element={
            <ProtectedRoute role="admin">
              <CatalogPage />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="/home" element={<Navigate to="/" replace />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
